import { useEffect, useRef, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSelector from '../components/LanguageSelector';

const Header = (props) => {
  const { t } = useTranslation();
  const [scrollPercentage, setScrollPercentage] = useState(0);
  const [imageSource, setImageSource] = useState('img/logo3.png');
  const handleScroll = () => {
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight - windowHeight;
    const scrolled = window.scrollY;
    const percentage = (scrolled / documentHeight) * 100;
    setScrollPercentage(percentage);

    // Change image source based on scroll percentage
    if (percentage > 1) {
      setImageSource('img/logo4.png');
    } else {
      setImageSource('img/logo3.png');
    }
  };
  const [maxWidth, setMaxWidth] = useState(window.innerWidth);
  const divRef = useRef(null);
  useEffect(() => {
    const handleResize = () => {
      setMaxWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('scroll', handleScroll);
    };
    
  }, []);

  const checkIsSticky = () => {
    if (divRef.current.classList !== null  && divRef.current.classList.contains('is-sticky')) {
      return true;
    } else {
      return false;
    }
  };
    return (
      <>
          <header id="header" className="header-transparent " >
          {/* Mobile language selector - positioned next to burger menu */}
         
          <div className="container">
      <div className="row">
        <div className="mobile-header-controls">
          <div className="mobile-lang-flag">
            <LanguageSelector isMobile={true} />
          </div>
          <div id="main-menu-trigger" onClick={() => window.openCloseMenu()} >
            <i className="fa fa-bars"></i>
          </div>
        </div>
        <div id="logo">
          <Link  to="/" className="light-logo">
            <img src="img/logo2.png" alt="Fleur de Sel Restaurant Luxembourg - Logo" /></Link>
            <Link to="/" className="dark-logo" >
              <img id="black-mobile-logo" src="img/logo_intro.png" alt="Fleur de Sel Restaurant Luxembourg"  />
              <img src={maxWidth <= 991 && imageSource} alt="Fleur de Sel Luxembourg"></img>
            </Link>
        </div>
        
        <nav id="main-menu" className="dark">
          <ul>
            <li><NavLink onClick={() => window.closeMenu()}  to="/" >{t('nav.home')}</NavLink></li>
            <li><NavLink onClick={() => window.closeMenu()}  to="/menu" >{t('nav.menu')}</NavLink></li>
            <li><NavLink onClick={() => window.closeMenu()}  to="/gallery">{t('nav.gallery')}</NavLink></li>
            <li><NavLink onClick={() => window.closeMenu()}  to="/events">{t('nav.events')}</NavLink></li>
            <li><NavLink onClick={() => window.closeMenu()}  to="/reservations">{t('nav.reservations')}</NavLink></li>
            <li><NavLink onClick={() => window.closeMenu()}  to="/contacts">{t('nav.contacts')}</NavLink></li>
            <li className="lang-selector-nav"><LanguageSelector /></li>
          </ul>
        </nav></div></div>
  </header>
 
  
  </>
    );
  };
  
  export default Header;
